import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTheme, styled } from "@mui/material/styles";
import {
  Toolbar,
  useMediaQuery,
  SwipeableDrawer,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab,
  IconButton,
  Button,
  Box,
  Paper,
  Badge,
  ListItemButton,
  Divider,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PartnerLogo from "assets/images/partner-logo.png";
import CuverdLogo from "assets/images/cuverd-logo-header.png";
import ProfessionalLogo from "assets/images/professional-logo.png";
import icon_notification from "assets/images/icon_notification.svg";
import walgreen_notification_icon from "assets/images/walgreen_notification_icon.png";
import { Link, useHistory } from "react-router-dom";
import { KeyboardArrowDown, Menu, Close } from "@mui/icons-material";
import MyAccountMenu from "pages/MyAccount/MyAccountMenu";
import { authenticationActions as authActions, homeActions } from "actions";
import { v4 as uuidv4 } from "uuid";
import MessageDialog from "pages/SearchMedication/MessageDialog";
import { homeService } from "services";

const Header = (props) => {
  const {
    value,
    setValue,
    resetSignUpStatus,
    resetLoginStatus,
    getMessagesCount,
    messagesCount,
    registerDevice,
    authenticateDevice,
    refreshToken,
    getTopTenProducts,
    getRecentSearch,
    registerInfo,
    authData,
    getGtmData,
    getDeviceDetails,
    getOrganizationLogo,
    organizationLogo,
    organizationInfo,
    organizationLogoProgress,
    stylingClass,
    deviceInfoProgress,
    topProductsIsProgress,
    topProducts,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesMd = useMediaQuery("(max-width:1000px)");

  const iOS =
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const storedRefreshToken = JSON.parse(sessionStorage.getItem("refreshToken"));
  const storedJwtToken = JSON.parse(sessionStorage.getItem("jwtToken"));
  const deviceData = JSON.parse(sessionStorage.getItem("deviceInfo"));
  const handleLogin = JSON.parse(sessionStorage.getItem("isLoggedIn"));
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showMyAccountMenu, setShowMyAccountMenu] = useState(false);
  const [highlightMyAccount, setHighlightMyAccount] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(handleLogin);
  const [timeIntervalSeconds, setTimeIntervalSeconds] = useState(290000);
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
   
  const Logo =
    organizationInfo?.app?.appCode === "CVD"
      ? CuverdLogo
      : organizationInfo?.app?.appCode === "HCP"
      ? ProfessionalLogo
      : PartnerLogo;
  const isWGN =
    organizationInfo?.suffix &&
    organizationInfo?.suffix?.toUpperCase() === "WGN";

  let routes = [];
  const routesArr = [
    { name: "Home", link: "/", activeIndex: 0 },
    {
      name: "Search for Medication",
      link: "/SearchMedication",
      activeIndex: 1,
    },
    { name: "How It Works", link: "/how-cuverd-works", activeIndex: 3 },
    { name: "About Us", link: "/aboutus", activeIndex: 4 },
    { name: "FAQs", link: "/frequently-asked-questions", activeIndex: 5 },
    { name: "", link: "/none", activeIndex: 6 },
    { name: "", link: "/none", activeIndex: 7 },
    { name: "", link: "/none", activeIndex: 8 },
  ];
  routes = routesArr;

  const [logoLoading, setLogoLoading] = useState(true);
  const myAccountRoutes = [
    "/MyAccount/MyCoupons",
    "/MyAccount/Profile",
    "/MyAccount/Settings",
  ];

  const CustomTabs = styled(Tabs)({
    "& .MuiTabs-indicator": {
      height: 5,
      borderRadius: 4,
      backgroundColor: "transparent",
    },
  });

  const CustomTab = styled((prop) => (
    <Tab component={Link} disableRipple {...prop} />
  ))((prop) => ({
    textTransform: "none",
    fontSize: matchesMd ? 14 : 20,
    minWidth: matchesMd ? 60 : 75,
    fontFamily: "Lato-Medium",
    letterSpacing: "0.6px",
    opacity: 1,
    color: prop?.color || "#083d4c",
    fontWeight: 400,
    "& .Mui-selected": {
      fontFamily: "Lato",
      letterSpacing: "0.4px",
      fontWeight: 900,
    },
  }));

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const clearData = () => {
    setValue(0);
    history.push("/");
  };

  useEffect(() => {
    if (!storedRefreshToken) {
      handleRegisterDevice();
    }
    getGtmData();
  }, []);

  useEffect(() => {
    if (refreshToken || storedRefreshToken) {
      authenticateDevice(refreshToken || storedRefreshToken);
    }
  }, [refreshToken]);

  useEffect(() => {
    const interval = setInterval(() => {
      authenticateDevice(storedRefreshToken);
    }, timeIntervalSeconds);
    return () => clearInterval(interval);
  }, [timeIntervalSeconds]);

  useEffect(() => {
    if (registerInfo && registerInfo.success === false) {
      setShowErrorDialog(true);
    }
  }, [registerInfo]);

  useEffect(() => {
    if (authData && Object.keys(authData).length) {
      if (
        authData.errorCode === "APP_CODE_NOT_FOUND" ||
        authData.errorCode === "APP_CODE_MISMATCH" ||
        authData.errorCode === "ORG_CODE_NOT_FOUND" ||
        authData.errorCode === "ORG_CODE_MISMATCH"
      ) {
        localStorage.removeItem("orgCode");
        localStorage.removeItem("appCode");
        window.location.reload();
      } else if (
        authData.errorCode === "REFRESH_TOKEN_INVALID" ||
        authData.errorCode === "REFRESH_TOKEN_INACTIVE" ||
        authData.errorCode === "INVALID_CREDENTIALS" ||
        authData.errorCode === "UNKNOWN" ||
        authData.status === 401
      ) {
        authenticateDevice(refreshToken);
      } else {
        let currentDay = new Date();
        const currentTime = currentDay.getTime() + 120000;
        const countdown = authData?.expiresIn - currentTime;
        setTimeIntervalSeconds(countdown);
      }
    }
  }, [authData]);

  const handleRegisterDevice = () => {
    const orgcode =
      localStorage.getItem("orgCode") ||
      window.location.href.split("//")[1].split(".")[0];
    let storedDeviceID = localStorage.getItem("deviceId");
    if (storedDeviceID == null) {
      storedDeviceID = uuidv4();
      //localStorage.setItem("deviceId", storedDeviceID);
    }
    let browserInfo = navigator.userAgent;
    let browserType = "WEB";
    const appCode = localStorage.getItem("appCode");
    registerDevice(storedDeviceID, browserType, browserInfo, appCode, orgcode);
  };

  useEffect(() => {
    if (
      logoLoading &&
      storedJwtToken &&
      (organizationInfo?.organizationOptionJson?.logoFileName ||
        organizationInfo?.organizationOptionJson?.logoFooterFileName ||
        organizationInfo?.organizationOptionJson?.mobileImage1FileName ||
        organizationInfo?.organizationOptionJson?.mobileImage2FileName ||
        organizationInfo?.relatedOrganizationQrFlag?.toLowerCase() === "y") &&
      !organizationLogoProgress
    ) {
      getOrganizationLogo();
      setLogoLoading(false);
    }
    if (storedJwtToken && !topProductsIsProgress && !topProducts.length) {
      getTopTenProducts();
      getRecentSearch();
    }
  }, [storedJwtToken, organizationInfo]);

  useEffect(() => {
    if (
      (window.location.pathname === "/" || !deviceData) &&
      storedJwtToken &&
      !deviceInfoProgress
    ) {
      getDeviceDetails();
    }

    if (
      storedJwtToken &&
      !topProductsIsProgress &&
      window.location.pathname === "/" &&
      window?.history?.length != 2
    ) {
      getTopTenProducts();
      getRecentSearch();
    }

    if (window?.location?.pathname?.includes("/savings")) {
      setValue(1);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    routes.forEach((route) => {
      switch (window.location.pathname) {
        case `${route.link}`:
          if (value !== route.activeIndex) {
            setValue(route.activeIndex);
          }
          break;
        case "/MyAccount/MyCoupons":
          setValue(5);
          break;
        case "/MyAccount/Settings":
          setValue(5);
          break;
        case "/MyAccount/Profile":
          setValue(5);
          break;
        case "/Notifications":
          setValue(5);
          break;
        default:
          break;
      }
    });
  }, [routes, value, setValue]);

  useEffect(() => {
    if (handleLogin) {
      setIsLoggedIn(handleLogin);
    }
  }, [handleLogin]);

  useEffect(() => {
    if (myAccountRoutes?.includes(window.location.pathname)) {
      setHighlightMyAccount(true);
    } else {
      setHighlightMyAccount(false);
    }
  }, [window?.location?.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      getMessagesCount();
    }
  }, [isLoggedIn]);

  const signOut = () => {
    homeService.logoutOut();
    setIsLoggedIn(false);
    setShowMyAccountMenu(false);
    setOpenDrawer(false);
    history.push("/");
  };

  const showWebPOSView = () => {
    if (
      organizationInfo?.organizationOptionJson?.signInOutFlag?.toLowerCase() !==
      "y"
    ) {
      return null;
    } else if (isLoggedIn) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Box
            ml={1}
            mr={3}
            component={Link}
            to="/Notifications"
            id="navNotifications"
          >
            <Badge
              badgeContent={messagesCount ? messagesCount.data : null}
              color="primary"
              sx={{
                marginLeft: "1.2rem",
                marginRight: "1rem",
                cursor: "pointer",
              }}
            >
              {isWGN ? (
                <img src={walgreen_notification_icon} alt="notification" />
              ) : (
                <img src={icon_notification} alt="notification" />
              )}
            </Badge>
          </Box>
          <Button
            variant={highlightMyAccount ? "filled" : "outline"}
            sx={{
              fontWeight: "bold",
              // borderColor: "#168e1e",
              // color: !isShowBackgroundAssets
              //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}  !important`
              //   : undefined,
            }}
            onClick={() => {
              setShowMyAccountMenu(true);
            }}
            endIcon={<KeyboardArrowDown />}
          >
            My Account
          </Button>
        </Box>
      );
    }
    return (
      <>
        {organizationInfo?.organizationOptionJson?.signInOutFlag?.toLowerCase() ===
          "y" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              position: "relative",
              alignItems: "center",
            }}
            ml={3}
          >
            <Button
              variant="filled"
              id="navSignUp"
              sx={{
                height: "50px",
                lineHeight: "20px",
                marginRight: 1,
                fontFamily: "Lato-Medium",
                fontSize: "16px",
                // color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`,
                // backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`,
                border: value === 6 ? "4px solid #000" : undefined,
              }}
              onClick={() => {
                resetSignUpStatus();
                history.push("/sign-up");
              }}
            >
              Sign Up
            </Button>
            <Button
              variant="filled"
              id="navSignIn"
              sx={{
                height: "50px",
                lineHeight: "20px",
                fontFamily: "Lato-Medium",
                fontSize: "16px",
                // color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`,
                // backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`,
                border: value === 7 ? "4px solid #000" : undefined,
              }}
              onClick={() => {
                resetLoginStatus();
                history.push("/SignIn");
              }}
            >
              Sign In
            </Button>
          </Box>
        )}
      </>
    );
  };

  const tabs = (
    <React.Fragment>
      <CustomTabs value={value} onChange={handleChange}>
        {routes.map((route, index) => (
          <Box
            key={route.activeIndex}
            sx={{
              display: "flex",
              justifyContent: "center",
              visibility:
                route.activeIndex === 6 ||
                route.activeIndex === 7 ||
                route.activeIndex === 8
                  ? "hidden"
                  : "",
              flexDirection: "column",
              alignItems: "center",
              width:
                route.activeIndex === 6 ||
                route.activeIndex === 7 ||
                route.activeIndex === 8
                  ? 0
                  : undefined,
            }}
            className={value === route.activeIndex ? `header-title-bold` : ""}
          >
            <CustomTab
              key={`${route}${index}`}
              to={route.link}
              label={route.name}
              color={`${organizationInfo?.colorSchemeJson?.menubarColor?.textColor}  !important`}
              onClick={() => {
                setValue(route.activeIndex);
              }}
            />
            {value === route.activeIndex ? (
              <span
                style={{
                  height: "5px",
                  borderRadius: 4,
                  backgroundImage: `linear-gradient(to right, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color} , ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color} 25%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color} 50%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color} 75%)`,
                  width: route.activeIndex === 6 ? 0 : 49,
                }}
              ></span>
            ) : null}
          </Box>
        ))}
      </CustomTabs>
      {showWebPOSView()}
      {showMyAccountMenu ? (
        <MyAccountMenu
          onCancel={() => setShowMyAccountMenu(false)}
          onSignOut={() => {
            signOut();
          }}
        />
      ) : null}
    </React.Fragment>
  );

  const showMobilePOSView = () => {
    if (defaultInsuranceId) {
      return null;
    } else if (isLoggedIn) {
      return (
        <>
          <ListItem
            button
            component={Link}
            to="/MyAccount/MyCoupons"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              My Coupons
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/MyAccount/Profile"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              Profile
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/MyAccount/Settings"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              Settings
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/"
            onClick={() => {
              signOut();

              //window.location.reload();
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              Sign Out
            </ListItemText>
          </ListItem>
          <Divider />
        </>
      );
    }
    return (
      <>
        {organizationInfo?.organizationOptionJson?.signInOutFlag?.toLowerCase() ===
          "y" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              position: "relative",
              marginLeft: matches ? "auto" : undefined,
              marginRight: matches ? "auto" : undefined,
            }}
            mt={3}
          >
            <Button
              variant="filled"
              id="navSignUp"
              sx={{
                marginRight: 1,
                fontFamily: "Lato-Medium",
                fontSize: "16px",
                color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`,
                backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`,
              }}
              onClick={() => {
                resetSignUpStatus();
                history.push("/sign-up");
                setOpenDrawer(false);
              }}
            >
              Sign Up
            </Button>
            <Button
              variant="filled"
              id="navSignIn"
              sx={{
                fontFamily: "Lato-Medium",
                fontSize: "16px",
                color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`,
                backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`,
              }}
              onClick={() => {
                history.push("/SignIn");
                setOpenDrawer(false);
              }}
            >
              Sign In
            </Button>
          </Box>
        )}
      </>
    );
  };

  const drawer = (
    <React.Fragment>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        open={openDrawer}
        anchor="right"
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
      >
        <List disablePadding>
          <ListItem
            disablePadding
            sx={{ backgroundColor: "#F0F2F0" }}
            secondaryAction={
              <IconButton
                edge="end"
                onClick={() => {
                  setOpenDrawer(false);
                }}
              >
                <Close sx={{ color: "#279842", fontSize: "28px" }} />
              </IconButton>
            }
          >
            <ListItemButton>
              <Menu sx={{ color: "#003d4c" }} />
              <ListItemText
                primaryTypographyProps={{
                  fontFamily: "Lato-Regular",
                  fontSize: "16px",
                  color: "#003d4c",
                }}
              >
                Menu
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              Home
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/SearchMedication"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              Search for Medication
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/how-cuverd-works"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              How It Works
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/aboutUs"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              About Us
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            button
            component={Link}
            to="/frequently-asked-questions"
            onClick={() => {
              setOpenDrawer(false);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "Lato-Semibold",
                fontSize: "20px",
                color: "#2b2e34",
              }}
            >
              FAQs
            </ListItemText>
          </ListItem>
          <Divider />
          {showMobilePOSView()}
        </List>
      </SwipeableDrawer>
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        style={{ marginLeft: "auto" }}
      >
        <MenuIcon
          sx={{
            color: `${organizationInfo?.colorSchemeJson?.menubarColor?.textColor}  !important`,
          }}
        />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Box className={stylingClass}>
      <Paper
        className="header-card"
        id="header-card"
        sx={{
          backgroundColor: `${organizationInfo?.colorSchemeJson?.menubarColor?.backgroundColor}  !important`,
          margin: matches ? "5px 20px 5px 20px" : undefined,
          padding: matches ? "0 16px" : undefined,
        }}
        square={false}
      >
        <Toolbar disableGutters={true} sx={{ width: "100%" }}>
          <Box component="div">
            <Button
              variant="text"
              onClick={clearData}
              sx={{ minWidth: "0", justifyContent: "flex-start" }}
            >
              {organizationInfo && (
                <img
                  className="header-logo"
                  alt="cuverd"
                  src={
                    organizationInfo?.organizationOptionJson?.logoFileName
                      ? organizationLogo?.logoBase64
                      : Logo
                  }
                  style={{
                    width: isWGN
                      ? matchesMinWidth
                        ? "170px"
                        : matchesMd
                        ? "180px"
                        : "240px"
                      : matchesMinWidth
                      ? "50%"
                      : matchesMd
                      ? "25%"
                      : undefined,
                  }}
                />
              )}
            </Button>
          </Box>
          <Box component="div" ml={"auto"} display="flex" alignItems="center">
            {isLoggedIn && matches ? (
              <Box
                mr={2}
                // onClick={() => getMessagesCount()}
                component={Link}
                id="navNotifications"
                to="/Notifications"
              >
                <Badge
                  badgeContent={messagesCount ? messagesCount.data : null}
                  color="primary"
                  sx={{ cursor: "pointer" }}
                >
                  {isWGN ? (
                    <img src={walgreen_notification_icon} alt="notification" />
                  ) : (
                    <img src={icon_notification} alt="notification" />
                  )}
                </Badge>
              </Box>
            ) : null}
            {matches ? drawer : tabs}
          </Box>
        </Toolbar>
      </Paper>
      <MessageDialog showPopUp={showErrorDialog}>
        <Box sx={{ maxWidth: "400px" }}>
          <Typography
            variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
            sx={{
              color: "#E94854",
              lineHeight: matchesMinWidth ? "24px" : "26px",
            }}
          >
            {registerInfo?.message}
          </Typography>
        </Box>
        <Box mt={5}>
          <Button
            variant="large"
            onClick={() => {
              setShowErrorDialog(false);
              window.location.reload();
            }}
            sx={{ minWidth: { xs: "150px", sm: "150px", md: "100%" } }}
          >
            TRY AGAIN
          </Button>
        </Box>
      </MessageDialog>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    loginStatus: state.signIn.loginStatus,
    messagesCount: state.messagesCount.data || "",
    refreshToken: state.authentication.refreshToken,
    jwtToken: state.authentication.jwtToken,
    authData: state.authentication.authData || {},
    recentList: state.recentSearch.data,
    clearRecentInfo: state.clearRecent.data,
    recentIsProgress: state.recentSearch.isProgress,
    registerInfo: state.authentication.registerInfo,
    organizationLogo: state.organizationLogo.data,
    organizationLogoProgress: state.organizationLogo.isProgress,
    organizationInfo: state.organizationInfo.data,
    deviceInfoProgress: state.deviceInfo.isProgress,
    contentInfo: state.contentType.data,
    topProductsIsProgress: state.topProducts.isProgress,
    topProducts: state.topProducts.data,
  };
};

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  getTopTenProducts: () => homeActions.getTopTenProducts(),
  getRecentSearch: () => homeActions.getRecentSearchList(),
  resetSignUpStatus: () => homeActions.resetSignUpStatus(),
  resetLoginStatus: () => homeActions.resetLoginStatus(),
  getMessagesCount: () => homeActions.getMessagesCount(),
  registerDevice: (deviceId, browserType, browserInfo, appCode, orgCode) =>
    authActions.registerDevice(
      deviceId,
      browserType,
      browserInfo,
      appCode,
      orgCode
    ),
  authenticateDevice: (value) => authActions.authenticateDevice(value),
  getPlaystoreLink: () => homeActions.getPlaystoreLink(),
  getDeviceDetails: () => homeActions.getDeviceDetails(),
  getGtmData: () => homeActions.getGTMDataLayer(),
  getOrganizationLogo: () => authActions.getOrganizationLogo(),
  resetInsuranceData: () => homeActions.resetInsuranceData(),
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
